/* Copyright (c) 2020-present CloudIO Inc */

/* eslint-disable @typescript-eslint/no-explicit-any */

import { useStateXAtomValue } from '@cloudio-saas/statex';
import {
  getManager,
  hmrReplace,
  ItemType,
  TriggerItemType,
} from 'componentregistry';
import type { Platform } from 'componentregistry/platform/Platform';
import { triggerNames } from 'componentregistry/triggers/TriggersManager';
import { hmrAtom } from 'designer/atoms';

export function accept(item: ItemType | 'ActionGoToRecord', module: any) {
  if (item === 'ActionGoToRecord') {
    (
      [
        'ActionGoToNextRecord',
        'ActionGoToPreviousRecord',
        'ActionGoToFirstRecord',
        'ActionGoToLastRecord',
      ] as ItemType[]
    ).forEach((_item) => {
      accept(_item, module);
    });
  } else {
    const mgr = getManager(item);
    mgr.defaultValue = module.defaultValue;
    mgr.platform.setter(hmrAtom, (counter = 0) => counter + 1);
  }
}

export function acceptTrigger(module: any) {
  let platform: Platform | undefined;
  (Object.keys(triggerNames) as TriggerItemType[]).forEach((item) => {
    const mgr = getManager(item);
    mgr.defaultValue = module.triggerDefaultValue;
    if (!platform && mgr?.platform) {
      platform = mgr.platform;
    }
  });
  if (platform) {
    platform.setter(hmrAtom, (counter = 0) => counter + 1);
  }
}

export function acceptManager(
  item: ItemType | 'ActionGoToRecord',
  module: any,
) {
  if (item === 'ActionGoToRecord') {
    (
      [
        'ActionGoToNextRecord',
        'ActionGoToPreviousRecord',
        'ActionGoToFirstRecord',
        'ActionGoToLastRecord',
      ] as ItemType[]
    ).forEach((_item) => {
      acceptManager(_item, { default: module.default(_item) });
    });
  } else {
    const mgr = hmrReplace(item, module.default);
    if (mgr?.platform) {
      mgr.platform.setter(hmrAtom, (counter = 0) => counter + 1);
    }
  }
}

export function acceptTriggerManager(module: any) {
  let platform: Platform | undefined;
  (Object.keys(triggerNames) as TriggerItemType[]).forEach((item) => {
    const mgr = hmrReplace(item, module.default());
    if (!platform && mgr?.platform) {
      platform = mgr.platform;
    }
  });
  if (platform) {
    platform.setter(hmrAtom, (counter = 0) => counter + 1);
  }
}

export function process(
  name: ItemType,
  webpackHot: any,
  module: any,
  isTrigger = false,
) {
  if (webpackHot.data?.value && webpackHot.data.value !== module) {
    if (name.endsWith('Manager')) {
      if (isTrigger) {
        acceptTriggerManager(module);
      } else {
        acceptManager(name.substring(0, name.length - 7) as ItemType, module);
      }
    } else {
      if (isTrigger) {
        acceptTrigger(module);
      } else {
        accept(name, module);
      }
    }
  }
  webpackHot.dispose((data: any) => {
    data.value = module;
  });
  webpackHot.accept();
}

export function useUpdateOnHMR() {
  return useStateXAtomValue(hmrAtom);
}
